import React, { useState } from 'react';
import { CloseOutlined, EditOutlined } from '@ant-design/icons';
import { Input, Button, Form } from 'antd';

interface GoalsFormProps {
  goals: Goal[];
  onUpdate: (goals: Goal[]) => void;
}

const GoalsForm: React.FC<GoalsFormProps> = ({ goals, onUpdate }) => {
  const [goal, setGoal] = useState<string>();
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [editingText, setEditingText] = useState<string>('');

  const handleAddGoal = (value: string) => {
    if (value && value.length) {
      onUpdate([
        {
          id: -1,
          text: value,
        },
        ...goals,
      ]);

      setGoal('');
    }
  };

  const handleRemoveGoal = (index: number) => {
    const newData = goals;
    if (newData[index]) {
      newData.splice(index, 1);
    }

    onUpdate([...newData]);
  };

  const handleStartEdit = (index: number) => {
    setEditingIndex(index);
    setEditingText(goals[index].text);
  };

  const handleSaveEdit = () => {
    if (editingIndex === null) return;
    if (editingText.trim().length === 0) return;

    const updatedGoals = [...goals];
    updatedGoals[editingIndex] = { ...updatedGoals[editingIndex], text: editingText.trim() };
    onUpdate(updatedGoals);
    setEditingIndex(null);
    setEditingText('');
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditingText('');
  };

  return (
    <Form.Item label="Goals">
      <Input.Search
        placeholder="Goal text"
        enterButton="Add goal"
        value={goal}
        onChange={(event) => setGoal(event.target.value)}
        onSearch={(value: string) => handleAddGoal(value)}
        onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            if (goal) {
              handleAddGoal(goal);
            }
          }
        }}
      />
      <ul>
        {goals.map((g, index) => (
          <li key={`${g.id}#${index}`}>
            {editingIndex === index ? (
              <Input
                value={editingText}
                onChange={(e) => setEditingText(e.target.value)}
                onPressEnter={handleSaveEdit}
                onKeyDown={(e) => {
                  if (e.key === 'Escape') {
                    handleCancelEdit();
                  }
                }}
                onBlur={handleSaveEdit}
                autoFocus
                style={{ width: 'calc(100% - 70px)', marginRight: 8 }}
              />
            ) : (
              <>
                {g.text}{' '}
                <Button
                  type="primary"
                  size="small"
                  ghost
                  onClick={() => handleStartEdit(index)}
                  style={{ marginRight: 4 }}
                >
                  <EditOutlined />
                </Button>
              </>
            )}
            <Button
              danger
              size="small"
              ghost
              onClick={() => {
                handleRemoveGoal(index);
                if (editingIndex === index) handleCancelEdit();
              }}
            >
              <CloseOutlined />
            </Button>
          </li>
        ))}
      </ul>
    </Form.Item>
  );
};

export default GoalsForm;
